var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.138 27.183c2.05 1.304 4.656.56 5.774-1.49l5.096-8.89 5.204 8.89c1.117 1.863 3.724 2.608 5.773 1.49 1.862-1.117 2.607-3.724 1.49-5.773L19.913 6.472a4.082 4.082 0 0 0-.962-1.278c-.818-.782-1.849-1.21-2.909-1.193a4.072 4.072 0 0 0-3.49 1.887c-.156.219-.29.451-.402.694l-8.5 14.83c-1.303 2.049-.558 4.656 1.49 5.773z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnc);
export default __webpack_public_path__ + "static/media/ANC.cb0cc139f20412cebf7228857c091b4e.svg";
export { ForwardRef as ReactComponent };